module.exports = ".filters {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n}\n\n.filter-group {\n  display: inline-block;\n\n  margin: 5px;\n}\n\n.filter-group label {\n  display: block;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/conf/stock-rule/stock-rule.component.css
// module id = ./src/app/conf/stock-rule/stock-rule.component.css
// module chunks = main